import { promptVars } from '../variables';
import { structureWithSchemaBasePrompt } from './structureBasePrompt';
export const generateStructureScopesPrompt = structureWithSchemaBasePrompt
    .temp(0.5)
    .human('Give me a structure of the application.')
    .ai(promptVars.structureDsl)
    .human('Check the structure and make sure it has all scopes needed for the application in existing views.');
//# sourceMappingURL=generateStructureScopesPrompt.js.map